import { FC, useContext } from "react";
import { IGroup, RequestState } from "../../types/ApiTypes";
import Button from "../ui/Button";
import { BsArrowCounterclockwise, BsCheck, BsTrash } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import { CgArrowsExchangeAlt } from "react-icons/cg";
import { useAccount } from "@azure/msal-react";
import { AppContext } from "../../context/AppContext";

interface Props {
  space: IGroup;
  onRemove: () => void;
  onSpaceRerun: () => void;
}

const SpaceDetailsActionButtons: FC<Props> = ({space, onRemove, onSpaceRerun}) => {
  const account = useAccount();
  const appCtx = useContext(AppContext);


  const isOwner = space.primary_owner === account?.localAccountId || space.secondary_owner === account?.localAccountId;
  const isRequester = space.requester === account?.localAccountId;
  const isAdmin = appCtx.state.roles.includes('ROLE_ADMIN');
  const needsAcceptance = space && (isOwner || isAdmin) && (space.request_state === RequestState.AwaitsAcceptance || !space.primary_accepted || !space.secondary_accepted);

  return (
    <div className='w-full flex justify-end gap-2'>
      {(isOwner || isAdmin) && (space.request_state === RequestState.AwaitsAcceptance) && (
        <Button className='bg-error-brighter hover:shadow-error-brighter/20' onClick={onRemove}>
          <BsTrash className='mr-2 text-xl'/> Löschen
        </Button>
      )}
      {(isOwner || isRequester || isAdmin) && (space.request_state === RequestState.Failed) && (
        <Button onClick={onSpaceRerun}>
          <BsArrowCounterclockwise className='mr-2 text-xl'/> Erneut erstellen
        </Button>
      )}
      {appCtx.state.settings.approvalTool === 'integrated' && needsAcceptance && (
        <NavLink to={`/space/acceptance/${space.requestId}`}>
          <Button>
            <BsCheck className='mr-2 text-xl'/> Zur Bestätigung
          </Button>
        </NavLink>
      )}
      {(isOwner || isAdmin) && space.request_state === RequestState.Completed && (
        <>
          <NavLink to={`/space/${space.requestId}/owner-change`}>
            <Button>
              <CgArrowsExchangeAlt className='mr-2 text-xl'/> Besitzer wechseln
            </Button>
          </NavLink>
        </>
      )}
    </div>
  );
};

export default SpaceDetailsActionButtons;